import { Button } from "@/components/ui/button";
interface TutorialButtonProps {
  onClick: () => void;
}
export const TutorialButton = ({
  onClick
}: TutorialButtonProps) => <Button variant="ghost" size="icon" className="absolute top-4 right-4 text-foreground hover:text-clubbers-red hover:bg-background/10 dark:text-white dark:hover:bg-white/10" onClick={onClick} title="Ver tutorial">
    
  </Button>;